import { useInterval } from "@org-avp/avp-avengers-ui-shared-utils";
import { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectDetachedViews, setDetachedViewTimestamp } from "../slices/detachedViewsSlice";
import { useAppDispatch } from "../utils/dispatchUtils";

const DETACHED_VIEW_TRACKING_INTERVAL = 5000;
const DETACHED_VIEW_CALCULATION_INTERVAL = 1000;

export function useDetachedViewTracker(viewKey: string): void {
  const appDispatch = useAppDispatch();
  const callback = useCallback(
    () => appDispatch(setDetachedViewTimestamp(viewKey)),
    [appDispatch, viewKey],
  );

  useInterval(callback, DETACHED_VIEW_TRACKING_INTERVAL);
}

export function useCurrentlyDetachedViews(): string[] {
  const detachedViewsState = useSelector(selectDetachedViews);
  const [detachedViews, setDetachedViews] = useState<string[]>([]);
  const updateDetachedViews = useCallback(
    () => {
      setDetachedViews(() => {
        const currentDate = new Date();
        const newDetachedViews: string[] = [];

        Object.entries(detachedViewsState).forEach(([viewKey, timestamp]) => {
          if (currentDate.getTime() - timestamp.getTime() < DETACHED_VIEW_TRACKING_INTERVAL + DETACHED_VIEW_CALCULATION_INTERVAL) {
            newDetachedViews.push(viewKey);
          }
        });

        return newDetachedViews.sort();
      });
    },
    [detachedViewsState],
  );

  useInterval(updateDetachedViews, DETACHED_VIEW_CALCULATION_INTERVAL);
  return useMemo(() => detachedViews, [detachedViews]);
}
